/**
 * These must correspond to the values in the job_user_statuses table in the database
 */
export enum JobUserStatusEnum {
  TRAVEL = 2,
  START_CONTINUE_WORK = 3,
  BREAK = 4,
  DAY_COMPLETE = 5,
  FINISH_WORK = 6,
  NONE_CHARGEABLE = 7
}